import { initialize } from 'redux-form'
import moment from 'moment'
import { getUser } from 'Common'
import modalProps from '../modalProps'
import { FORM_NAME } from '../Form'

export default () => (dispatch) => {
  
  const { subInvoice, subcontractorId } = modalProps()

  if (subInvoice) {

    dispatch(initialize(FORM_NAME, subInvoice))
    
  } else {

    dispatch(initialize(FORM_NAME, {
      subcontractor_id: subcontractorId,
      user_id: getUser().id,
      date: moment().format('YYYY-MM-DD'),
    }))

  }

}
